<template>
  <div>
    <b-card no-body>
      <b-form @submit="onSubmit" class="row">
        <div class="col-12 d-flex justify-content-center">
          <upload-foto @upload="(img) => (form.foto = img)" :fotoSrc="form.foto" />
        </div>
        <div class="col-12 d-flex justify-content-center mb-4">
          <h4>{{ form.nome }}</h4>
        </div>
        <input-text
          class="col-12 col-md-6"
          label="Nome"
          v-model="form.nome"
          ref="pessoa-nome"
          required
        />
        <!--<input-date-time class="col-12 col-md-3" label="Data de nascimento" v-model="form.dataNascimento" ref="pessoa-dataNascimento" required/>-->
        <input-select
          :class="`col-12 col-md-${form.nacionalidade == 'Estrangeira' ? '3' : '3'}`"
          label="Titulação"
          :options="options.titulacao"
          v-model="form.titulacao"
          ref="pessoa-titulacao"
          required
        />
        <input-select
          :class="`col-12 col-md-3`"
          label="Nacionalidade"
          :options="options.nacionalidade"
          v-model="form.nacionalidade"
          ref="pessoa-nacionalidade"
          required
        />
        <input-mask
          :mask="['###.###.###-##']"
          class="col-12 col-md-3"
          label="CPF"
          v-if="form.nacionalidade != 'Estrangeira'"
          v-model="form.cpf"
          ref="pessoa-cpf"
          required
          type="cpf"
        />
        <input-text
          class="col-12 col-md-3"
          label="Passaporte"
          v-model="form.passaporte"
          v-if="form.nacionalidade == 'Estrangeira'"
          ref="pessoa-passaporte"
          required
        />
        <input-select
          class="col-12 col-md-3"
          label="UF"
          :options="options.uf"
          v-model="form.endereco.uf"
          v-if="form.nacionalidade != 'Estrangeira'"
          ref="pessoa-uf"
          required
        />
        <input-select
          class="col-12 col-md-6"
          label="Cidade"
          :options="options.cidades"
          v-model="form.endereco.cidade"
          v-if="form.nacionalidade != 'Estrangeira'"
          ref="pessoa-cidade"
          required
        />
        <!--<input-mask :mask="['(##) ####-####', '(##) #####-####']" :class="`col-12 col-md-4`" label="Telefone" v-model="form.telefone" ref="pessoa-telefone" required/>-->
        <input-mask
          :mask="['(##) ####-####', '(##) #####-####']"
          :class="`col-12 col-md-3`"
          label="Celular"
          v-model="form.celular"
          ref="pessoa-celular"
          required
        />
        <input-text
          :class="`col-12 col-md-${form.nacionalidade == 'Estrangeira' ? '6' : '9'}`"
          label="Email"
          v-model="form.email"
          ref="pessoa-email"
          required
          type="email"
        />
        <input-text
          :class="`col-12`"
          label="Link currículo LATTES"
          v-model="form.linkCurriculoLattes"
          ref="pessoa-lattes"
        />
        <div class="col-12">
          <b-button variant="success" type="submit">
            <i class="fa-solid fa-check mr-2"></i>
            Salvar
          </b-button>
        </div>
      </b-form>
    </b-card>
    <b-card no-body class="mt-4">
      <div class="row">
        <input-text
          class="col-12 col-md-4"
          type="password"
          label="Senha atual"
          v-model="password.senhaAtual"
          ref="senha-senha"
          required
        />
        <div class="col-12 col-md-4">
          <input-text
            type="password"
            label="Nova senha"
            v-model="password.novaSenha"
            ref="senha-novasenha"
            required
          />
          <b-badge v-if="senhaForte" :variant="senhaForte.variant">
            {{ senhaForte.text }}
          </b-badge>
        </div>
        <input-text
          class="col-12 col-md-4"
          type="password"
          label="Confirme a nova senha"
          v-model="password.novaSenhaConfirmacao"
          ref="senha-confimasenha"
          required
        />
        <div class="col-12">
          <b-button variant="primary" @click="onResetPassword">Alterar senha</b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import UploadFoto from "@/components/uploadFoto/UploadFoto";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputMask from "@/components/inputs/InputMask";

import Nacionalidade from "@/common/mock/Nacionalidade";
import Titulacao from "@/common/mock/Titulacao";
import UF from "@/common/mock/UF";

import PessoaService from "@/common/services/pessoa/pessoa.service";
import UsuarioService from "@/common/services/usuario/usuario.service";
import InfosService from "@/common/services/infos/infos.service";

import Swal from "sweetalert2";

import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import { FormMixin } from "@/common/mixins/FormMixin";

export default {
  mixins: [FormMixin],
  components: {
    UploadFoto,
    InputText,
    InputSelect,
    //InputDateTime,
    InputMask,
  },
  data: () => ({
    form: {
      nome: null,
      email: null,
      cpf: null,
      nacionalidade: null,
      telefone: null,
      passaporte: null,
      titulacao: null,
      foto: null,
      celular: null,
      dataNascimento: null,
      endereco: {
        cidade: null,
        uf: null,
      },
      id: null,
      linkCurriculoLattes: null,
    },

    password: {
      senhaAtual: null,
      novaSenhaConfirmacao: null,
      novaSenha: null,
    },

    options: {
      nacionalidade: Nacionalidade,
      titulacao: Titulacao,
      uf: UF,
      cidades: [],
    },
  }),
  methods: {
    fetchUser: function () {
      UsuarioService.me().then((response) => {
        this.form = response.data.data.pessoa;
      });
    },
    onSubmit: function (e) {
      e.preventDefault();

      Swal.fire({
        title: "Aviso",
        text: "Deseja atualizar os dados do perfil?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sim",
        denyButtonText: `Não`,
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.validateState("pessoa-") == false) return;

          this.$store.dispatch(START_LOADING);

          PessoaService.atualizarMe(this.form)
            .then(() => {
              this.$store.dispatch("app/fetchUserData");

              Swal.fire({
                title: "Sucesso",
                text: "Perfil atualizado com sucesso!",
                icon: "success",
              });
            })
            .catch(() => {
              Swal.fire({
                title: "Erro",
                text: "Ocorreu um erro ao atualizar o perfil",
                icon: "error",
                confirmButtonText: "Ok",
              });
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
    onResetPassword: function () {
      Swal.fire({
        title: "Aviso",
        text: "Deseja alterar a senha?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sim",
        denyButtonText: `Não`,
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.validateState("senha-") == false) return;
          if (this.password.novaSenha != this.password.novaSenhaConfirmacao) {
            Swal.fire({
              title: "Erro",
              text: "As senhas não conferem",
              icon: "error",
              confirmButtonText: "Ok",
            });
            return;
          }
          this.$store.dispatch(START_LOADING);

          UsuarioService.alterarSenha(this.password)
            .then(() => {
              Swal.fire({
                title: "Sucesso",
                text: "Senha alterada com sucesso!",
                icon: "success",
              });
            })
            .catch(() => {
              Swal.fire({
                title: "Erro",
                text: "Ocorreu um erro ao alterar a senha",
                icon: "error",
                confirmButtonText: "Ok",
              });
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
  },
  mounted() {
    this.fetchUser();
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: "Meu perfil" }]);
  },
  watch: {
    "form.endereco.uf": function () {
      InfosService.buscarCidades(this.form.endereco.uf).then((res) => {
        this.options.cidades = res.data.data.map((el) => {
          return {
            text: el.nome,
            value: el.nome,
          };
        });
      });
    },
  },
  computed: {
    senhaForte: function () {
      var numeros = /([0-9])/;
      var alfabeto = /([a-zA-Z])/;
      var chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;

      if (!this.password.novaSenha) {
        return null;
      }

      if (this.password.novaSenha.length < 6) {
        return {
          variant: "danger",
          text: "Fraco, insira no mínimo 6 caracteres",
        };
      } else {
        if (
          this.password.novaSenha.match(numeros) &&
          this.password.novaSenha.match(alfabeto) &&
          this.password.novaSenha.match(chEspeciais)
        ) {
          return {
            variant: "success",
            text: "Senha forte",
          };
        } else {
          return {
            variant: "warning",
            text: "Fraco, insira no mínimo 1 número, 1 letra e 1 caractere especial",
          };
        }
      }
    },
  },
};
</script>
<style>
.card {
  min-height: inherit !important;
}
</style>
